interface Props {
	title: string
	description?: string
	imgPath?: string
	edit?: () => void
}

const ProductLineCard: React.FC<Props> = ({
	title,
	description,
	imgPath = '/media/icons/kumopack/default-placeholder-transparent.png',
	edit,
}) => {
	return (
		<div
			className="card border border-kumopack-grey-200 h-100 hover-opacity-05 transition-300 cursor-pointer"
			onClick={edit}>
			<img
				className="card-img-top bg-kumopack-grey-200 h-250px object-fit-cover"
				src={imgPath}
				alt="Product"
				onError={(e: any) => {
					e.target.onerror = null
					e.target.src = '/media/icons/kumopack/default-placeholder-transparent.png'
				}}
				style={{ userSelect: 'none', pointerEvents: 'none' }}
			/>

			<div className="card-body p-5">
				{/* Name */}
				<div className="fw-bold fs-2">{title}</div>

				{/* Description */}
				{description && <div className="text-kumopack-grey-700">{description}</div>}
			</div>

			<div className="card-footer border-0 px-5">
				<div
					className="badge bg-kumopack-grey-100 text-kumopack-grey-700 cursor-pointer"
					onClick={edit}>
					<img
						className="me-1"
						src={'/media/icons/kumopack/small-edit-05.svg'}
						alt="Small Edit Pencil Icon"
						onError={(e: any) => {
							e.target.onerror = null
							e.target.src = '/media/icons/kumopack/default-placeholder-transparent.png'
						}}
						style={{ userSelect: 'none', pointerEvents: 'none' }}
					/>
					แก้ไขรายละเอียด
				</div>
			</div>
		</div>
	)
}

export default ProductLineCard
